/* ===== DisConnect theme — ported from the site prototype ===== */
(() => {
const $ = (s, el = document) => el.querySelector(s);
const $$ = (s, el = document) => [...el.querySelectorAll(s)];
const DC = window.DC || {};
const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const dollars = n => '$' + n.toLocaleString('en-US', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
const money = cents => dollars(Math.round(cents) / 100);
const EMAIL = /^[^ @]+@[^ @]+[.][^ @]+$/;
const fmt = n => Math.round(n).toLocaleString('en-US');
const per = (t = '') => { t = String(t).toLowerCase(); return /annual|year/.test(t) ? '/yr' : /quarter/.test(t) ? '/3 mo' : /month/.test(t) ? '/mo' : /life|once/.test(t) ? ' once' : ''; };
const memHandle = DC.mem && DC.mem.handle, cardHandle = DC.card && DC.card.handle;
const memVariant = () => DC.mem && (DC.mem.variants.find(v => v.id === DC.memVariantId) || DC.mem.variants[0]);
const cardVariant = () => DC.card && DC.card.variants[0];

/* ---- procedural art: sky, grain, card faces (same as prototype) ---- */
const SCRIPT_FONT = 'Pinyon Script';
function rng(seed) { let s = seed >>> 0; return () => ((s = (s * 1664525 + 1013904223) >>> 0) / 4294967296); }
function drawClouds(ctx, w, h, seed, density = 1) {
  const r = rng(seed);
  const g = ctx.createLinearGradient(0, 0, 0, h);
  g.addColorStop(0, '#6ea4ff'); g.addColorStop(.55, '#8ebbff'); g.addColorStop(1, '#cfe1ff');
  ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);
  const banks = Math.round(7 * density);
  ctx.save();
  try { ctx.filter = `blur(${Math.max(2, w / 260)}px)`; } catch (e) {}
  for (let b = 0; b < banks; b++) {
    const cx = r() * w * 1.1 - w * .05, cy = h * (.15 + r() * .9), bw = w * (.18 + r() * .35), bh = bw * (.28 + r() * .2);
    const puffs = 26 + Math.floor(r() * 20);
    for (let i = 0; i < puffs; i++) {
      const px = cx + (r() - .5) * bw, py = cy + (r() - .7) * bh * .9, pr = bh * (.25 + r() * .55);
      const rg = ctx.createRadialGradient(px, py - pr * .25, 0, px, py, pr);
      const a = .18 + r() * .28;
      rg.addColorStop(0, `rgba(255,255,255,${a + .25})`); rg.addColorStop(.55, `rgba(255,255,255,${a})`); rg.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.fillStyle = rg; ctx.beginPath(); ctx.arc(px, py, pr, 0, Math.PI * 2); ctx.fill();
    }
    const sg = ctx.createRadialGradient(cx, cy + bh * .25, 0, cx, cy + bh * .25, bw * .5);
    sg.addColorStop(0, 'rgba(120,150,200,.10)'); sg.addColorStop(1, 'rgba(120,150,200,0)');
    ctx.fillStyle = sg; ctx.fillRect(cx - bw, cy - bh, bw * 2, bh * 2);
  }
  ctx.restore();
}
function makeGrain() {
  const c = document.createElement('canvas'); c.width = c.height = 160;
  const x = c.getContext('2d'), d = x.createImageData(160, 160), r = rng(7);
  for (let i = 0; i < d.data.length; i += 4) { const v = 150 + r() * 105; d.data[i] = d.data[i + 1] = d.data[i + 2] = v; d.data[i + 3] = 255; }
  x.putImageData(d, 0, 0); return c.toDataURL('image/png');
}
function pixelText(text, { size = 30, color = '#ffff81', shadow = null } = {}) {
  const f = `${size}px "${SCRIPT_FONT}", "LucidWake", "Pinyon Script", cursive`;
  const m = document.createElement('canvas').getContext('2d'); m.font = f;
  const tw = Math.ceil(m.measureText(text).width + size * .5), th = Math.ceil(size * 1.45);
  const c = document.createElement('canvas'); c.width = tw; c.height = th;
  const x = c.getContext('2d'); x.font = f; x.textBaseline = 'middle';
  if (shadow) { x.fillStyle = shadow; x.fillText(text, size * .25 + 1, th / 2 + 1); }
  x.fillStyle = color; x.fillText(text, size * .25, th / 2);
  const d = x.getImageData(0, 0, tw, th); for (let i = 3; i < d.data.length; i += 4) d.data[i] = d.data[i] > 100 ? 255 : 0; x.putImageData(d, 0, 0);
  return { canvas: c, w: tw, h: th, url: c.toDataURL('image/png') };
}
function roundRect(x, X, Y, W, H, R) { x.beginPath(); x.moveTo(X + R, Y); x.arcTo(X + W, Y, X + W, Y + H, R); x.arcTo(X + W, Y + H, X, Y + H, R); x.arcTo(X, Y + H, X, Y, R); x.arcTo(X, Y, X + W, Y, R); x.closePath(); }
function makeCardFront(seed = 11) {
  const W = 856, H = 540, c = document.createElement('canvas'); c.width = W; c.height = H;
  const x = c.getContext('2d'); roundRect(x, 0, 0, W, H, 44); x.clip();
  drawClouds(x, W, H, seed, 1.1);
  const t = pixelText('DisConnect', { size: 44, color: '#ffff81', shadow: 'rgba(0,54,110,.55)' });
  x.imageSmoothingEnabled = false;
  const sw = t.w * 4.1, sh = t.h * 4.1; x.drawImage(t.canvas, (W - sw) / 2 + 10, (H - sh) / 2 - 6, sw, sh);
  const gl = x.createLinearGradient(0, 0, W, H); gl.addColorStop(0, 'rgba(255,255,255,.28)'); gl.addColorStop(.35, 'rgba(255,255,255,0)'); gl.addColorStop(.7, 'rgba(255,255,255,0)'); gl.addColorStop(1, 'rgba(255,255,255,.12)');
  x.fillStyle = gl; x.fillRect(0, 0, W, H);
  x.strokeStyle = 'rgba(255,255,239,.9)'; x.lineWidth = 5; x.lineCap = 'round';
  [18, 32, 46].forEach(r => { x.beginPath(); x.arc(W - 80, 74, r, -Math.PI / 3.2, Math.PI / 3.2); x.stroke(); });
  return c.toDataURL('image/png');
}
function makeCardBack(name = 'YOUR NAME HERE', num = '0347') {
  const W = 856, H = 540, c = document.createElement('canvas'); c.width = W; c.height = H;
  const x = c.getContext('2d'); roundRect(x, 0, 0, W, H, 44); x.clip();
  x.fillStyle = '#ffffef'; x.fillRect(0, 0, W, H);
  x.save(); x.beginPath(); x.rect(0, 0, W, 150); x.clip(); drawClouds(x, W, 150, 5, .6); x.restore();
  x.fillStyle = '#005497'; x.font = '700 22px "Space Mono", monospace'; x.fillText('MEMBER Nº', 56, 212);
  x.font = '700 58px "Space Mono", monospace'; x.fillText('DC-' + num.padStart(4, '0'), 56, 276);
  x.font = '700 24px "Space Mono", monospace'; x.fillText(name.toUpperCase().slice(0, 26), 56, 330);
  const r = rng(num.split('').reduce((a, b) => a + b.charCodeAt(0), 3)); let bx = 56;
  x.fillStyle = '#0b2a4f'; while (bx < 520) { const bw = 2 + Math.floor(r() * 6); if (r() > .35) x.fillRect(bx, 380, bw, 92); bx += bw + 2 + Math.floor(r() * 3); }
  x.font = '18px "Space Mono", monospace'; x.fillText('TAP TO LOCK · TAP IN TO GO', 56, 500);
  const t = pixelText('DisConnect', { size: 22, color: '#005497' }); x.imageSmoothingEnabled = false; x.drawImage(t.canvas, W - t.w * 3 - 40, 180, t.w * 3, t.h * 3);
  x.strokeStyle = '#005497'; x.lineWidth = 5; x.lineCap = 'round';
  [18, 32, 46].forEach(rr => { x.beginPath(); x.arc(W - 120, 430, rr, -Math.PI / 3.2, Math.PI / 3.2); x.stroke(); });
  x.font = '16px "Space Mono", monospace'; x.fillStyle = '#2f6fae'; x.fillText('disconnectcard.com', W - 250, 500);
  return c.toDataURL('image/png');
}
function makeSky(w = 1600, h = 900, seed = 3) { const c = document.createElement('canvas'); c.width = w; c.height = h; drawClouds(c.getContext('2d'), w, h, seed, 1.3); return c.toDataURL('image/jpeg', .82); }

const ART = {};
const ART_KEY = 'dc_art_v3';
const PIX = {};
function generateArt() {
  ART.grain = makeGrain(); ART.sky = makeSky(); ART.front = makeCardFront(); ART.back = makeCardBack();
  const l = pixelText('DisConnect', { size: 22, color: '#005497' }); ART.logo = { url: l.url, w: l.w, h: l.h };
  for (const k in PIX) delete PIX[k];
}
function applyArt(root = document) {
  const r = document.documentElement.style;
  r.setProperty('--grain', `url(${ART.grain})`);
  r.setProperty('--sky-img', `url(${ART.sky})`);
  $$('img[data-art]', root).forEach(i => { if (ART[i.dataset.art]) i.src = ART[i.dataset.art]; });
  $$('.logo', root).forEach(a => { a.innerHTML = `<img src="${ART.logo.url}" alt="DisConnect" style="width:${ART.logo.w * 1.6}px">`; });
  $$('img[data-pix]', root).forEach(img => {
    const t = PIX[img.dataset.pix] || (PIX[img.dataset.pix] = (({ url, w, h }) => ({ url, w, h }))(pixelText(img.dataset.pix, { size: 30, color: '#ffff81', shadow: 'rgba(11,42,79,.7)' })));
    img.src = t.url; img.style.aspectRatio = `${t.w}/${t.h}`;
  });
}
function initArt() {
  let cached = null;
  try { cached = JSON.parse(localStorage.getItem(ART_KEY) || 'null'); } catch (e) {}
  if (cached && cached.front) { Object.assign(ART, cached); applyArt(); return; }
  generateArt(); applyArt();
  const wanted = [`40px "${SCRIPT_FONT}"`, '20px "Space Mono"', '700 20px "Space Mono"', '20px "VT323"'];
  Promise.allSettled(wanted.map(f => document.fonts.load(f))).then(() => document.fonts.ready).then(() => {
    const ok = document.fonts.check(`40px "${SCRIPT_FONT}"`);
    generateArt(); applyArt();
    if (ok) try { localStorage.setItem(ART_KEY, JSON.stringify({ grain: ART.grain, sky: ART.sky, front: ART.front, back: ART.back, logo: ART.logo })); } catch (e) {}
  });
}

/* ---- toast ---- */
let toastT;
function toast(msg) { const t = $('#toast'); if (!t) return; t.textContent = msg; t.classList.add('show'); clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('show'), 2400); }
window.dcToast = toast;

/* ---- header / menu / drawer ---- */
function closeMenu() { $('#mnav')?.classList.remove('open'); $('#menuBtn')?.setAttribute('aria-expanded', 'false'); }
function openDrawer() { const d = $('#drawer'); d.classList.add('open'); $('#scrim').classList.add('open'); d.setAttribute('aria-hidden', 'false'); setTimeout(() => $('#drawerClose')?.focus(), 50); }
function closeDrawer() { const d = $('#drawer'); if (!d) return; d.classList.remove('open'); $('#scrim').classList.remove('open'); d.setAttribute('aria-hidden', 'true'); }
function wireShell() {
  $('#cartBtn')?.addEventListener('click', e => { e.preventDefault(); openDrawer(); Cart.refresh(); });
  $('#menuBtn')?.addEventListener('click', () => { $('#mnav').classList.add('open'); $('#menuBtn').setAttribute('aria-expanded', 'true'); });
  $('#menuClose')?.addEventListener('click', closeMenu);
  $$('#mnav a').forEach(a => a.addEventListener('click', closeMenu));
  $('#scrim')?.addEventListener('click', closeDrawer);
  $('#drawerClose')?.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeDrawer(); closeMenu(); } });
  $$('a.store-btn[href="#"]').forEach(a => a.addEventListener('click', e => { e.preventDefault(); toast('App links are coming soon.'); }));
}

/* ---- cart (Shopify AJAX API) ---- */
const Cart = {
  data: null,
  async req(path, body) {
    const r = await fetch(ROOT + path, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } });
    const j = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong. Try again.');
    return j;
  },
  async refresh() { this.data = await this.req('cart.js'); renderBadge(); renderDrawer(); return this.data; },
  async add(items, { open = true } = {}) {
    await this.req('cart/add.js', { items });
    await this.refresh();
    if (open) openDrawer();
  },
  async change(line, quantity) { $('#drawerBody')?.classList.add('busy'); try { this.data = await this.req('cart/change.js', { line, quantity }); } finally { $('#drawerBody')?.classList.remove('busy'); } renderBadge(); renderDrawer(); }
};
window.dcCart = Cart;
function renderBadge() { const b = $('#cartBadge'); if (b && Cart.data) { const n = Cart.data.item_count; b.textContent = n; b.dataset.n = n; } }
function lineHTML(it, line) {
  const ours = it.handle === memHandle || it.handle === cardHandle || !it.image;
  const thumb = ours ? `<img data-art="front" src="${ART.front || ''}" alt="">` : `<img data-real src="${esc(it.image)}" alt="">`;
  const isMem = it.handle === memHandle;
  const vt = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
  const vr = isMem ? `${esc(vt)} · ${money(it.price)}${per(vt)}` : it.handle === cardHandle ? 'NFC card · 30 days of Membership' : esc(vt);
  const gift = it.properties && it.properties['Gift for'] ? ` · <b>Gift for ${esc(it.properties['Gift for'])}</b>` : '';
  const was = it.original_line_price > it.final_line_price ? `<div class="tiny strike">${money(it.original_line_price)}</div>` : '';
  return `<div class="line">
    <div class="th">${thumb}</div>
    <div><div class="nm">${esc(it.product_title)}</div><div class="vr">${vr}${gift}</div>
      <div class="row" style="--gap:0"><div class="qty"><button aria-label="Decrease quantity" data-line="${line}" data-to="${it.quantity - 1}">−</button><span>${it.quantity}</span><button aria-label="Increase quantity" data-line="${line}" data-to="${it.quantity + 1}">+</button></div><button class="rm" data-line="${line}" data-to="0">Remove</button></div>
    </div>
    <div class="pr">${money(it.final_line_price)}${was}</div></div>`;
}
function upsellHTML(items) {
  const mv = memVariant(), cv = cardVariant(); if (!mv || !cv) return '';
  const hasMem = items.some(i => i.handle === memHandle);
  const single = items.findIndex(i => i.handle === cardHandle && !(i.properties && i.properties['Gift for']));
  if (!hasMem && single > -1) {
    const diff = mv.price - cv.price;
    return `<div class="upsell"><div><b>${diff > 0 ? `Upgrade for ${money(diff)} more.` : 'Upgrade to Membership.'}</b> Founding Membership comes with the card, the welcome kit and a year of real rewards. ${money(mv.price)} instead of ${money(cv.price)}, and it ships free.</div><button class="btn sm" data-upgrade="${single + 1}">Swap to Founding Membership — ${money(mv.price)}</button></div>`;
  }
  if (hasMem && !items.some(i => i.handle === cardHandle)) return `<div class="upsell"><div><b>Give one to the friend who needs it most.</b> A card comes with 30 days of Membership. Add a gift note at checkout.</div><button class="btn sm" data-addgift>Add a card for a friend — ${money(cv.price)}</button></div>`;
  return '';
}
function renderDrawer() {
  const body = $('#drawerBody'), foot = $('#drawerFoot'); if (!body) return;
  const c = Cart.data || { items: [], item_count: 0 };
  const n = c.item_count;
  $('#drawerTitle').textContent = `cart.exe — ${n} item${n === 1 ? '' : 's'}`;
  if (!c.items.length) {
    body.innerHTML = `<div class="empty"><img data-art="front" src="${ART.front || ''}" alt="" style="width:180px;border-radius:10px;box-shadow:var(--soft)"><h3>Nothing in here yet.</h3><p class="muted">Your phone has a whole team working on it. Get one on your side.</p><a class="btn" href="${DC.mem ? DC.mem.url : ROOT}">Shop the card</a></div>`;
    foot.hidden = true; return;
  }
  const hasMem = c.items.some(i => i.handle === memHandle);
  const sub = c.total_price, freeAt = DC.freeShipAt || 0;
  const need = Math.max(0, freeAt - sub);
  const shipMsg = (hasMem || need === 0) ? '<b>Free shipping unlocked.</b>' : `You're <b>${money(need)}</b> away from free shipping.`;
  const pct = hasMem || !freeAt ? 100 : Math.min(100, sub / freeAt * 100);
  body.innerHTML = `${freeAt ? `<div class="meter"><div class="meter-top"><span>${shipMsg}</span></div><div class="meter-bar"><i style="width:${pct}%"></i></div></div>` : ''}
    ${c.items.map((it, i) => lineHTML(it, i + 1)).join('<hr class="rule">')}
    ${upsellHTML(c.items)}`;
  foot.hidden = false;
  $('#dSub').textContent = money(c.items_subtotal_price);
  const disc = c.items_subtotal_price - c.total_price;
  $('#dDiscRow').hidden = !(disc > 0); $('#dDisc').textContent = '−' + money(disc);
  $('#dCheckout').textContent = `Checkout — ${money(c.total_price)}`;
  $$('[data-line]', body).forEach(b => b.onclick = () => Cart.change(+b.dataset.line, Math.max(0, +b.dataset.to)).catch(e => toast(e.message)));
  const up = $('[data-upgrade]', body);
  if (up) up.onclick = async () => {
    const line = +up.dataset.upgrade, it = c.items[line - 1];
    try { await Cart.change(line, it.quantity - 1); await Cart.add([{ id: memVariant().id, quantity: 1 }], { open: false }); toast('Upgraded. Card included.'); } catch (e) { toast(e.message); }
  };
  const ag = $('[data-addgift]', body);
  if (ag) ag.onclick = () => Cart.add([{ id: cardVariant().id, quantity: 1 }], { open: false }).then(() => toast('Card added. Add a gift note at checkout.')).catch(e => toast(e.message));
}
async function addWithButton(btn, items, opts) {
  btn && btn.classList.add('is-loading');
  try { await Cart.add(items, opts); return true; } catch (e) { toast(e.message); return false; } finally { btn && btn.classList.remove('is-loading'); }
}

/* ---- gallery ---- */
function wireGallery(root) {
  if (!root || !$('[data-prev]', root)) return null;
  const slides = $$('[data-slide]', root), thumbs = $$('[data-go]', root); let cur = Math.max(0, slides.findIndex(s => s.classList.contains('on')));
  const go = i => { cur = (i + slides.length) % slides.length; slides.forEach((s, j) => { s.classList.toggle('on', j === cur); s.setAttribute('aria-hidden', j !== cur); }); thumbs.forEach((t, j) => t.setAttribute('aria-pressed', j === cur)); $('[data-tag]', root).textContent = thumbs[cur].getAttribute('aria-label').replace('Show ', ''); };
  thumbs.forEach(t => t.onclick = () => go(+t.dataset.go));
  $('[data-prev]', root).onclick = () => go(cur - 1); $('[data-next]', root).onclick = () => go(cur + 1);
  const tilt = $('[data-tilt]', root), stage = $('.stage', root);
  if (tilt && matchMedia('(pointer:fine)').matches && !matchMedia('(prefers-reduced-motion:reduce)').matches) {
    stage.addEventListener('pointermove', e => { const r = stage.getBoundingClientRect(); const x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5; tilt.style.transform = `rotateY(${x * 18}deg) rotateX(${-y * 14}deg)`; });
    stage.addEventListener('pointerleave', () => tilt.style.transform = '');
  }
  return go;
}

/* ---- home: pick your way in ---- */
function wireTiers(go) {
  const cta = $('#heroCta'), extra = $('#tierExtra'); if (!cta || !extra) return;
  const tier = () => ($('input[name=tier]:checked') || {}).value;
  const render = () => {
    const t = tier();
    $$('[data-extra]', extra).forEach(e => e.hidden = e.dataset.extra !== t);
    if (t === 'membership') { const p = $('input[name=plan]:checked', extra); if (p) { cta.textContent = `Add to cart — ${p.dataset.price}${p.dataset.per || ''}`; const m = $('#heroMeter'); if (m) m.hidden = p.dataset.founding !== '1'; } }
    else if (t === 'card') { const p = $('input[name=pack]:checked', extra); if (p) cta.textContent = `Add ${p.dataset.label} — ${p.dataset.price}`; }
    else cta.textContent = `Or start with the card — ${cta.dataset.cardPrice}`;
  };
  $$('input[name=tier]').forEach(i => i.onchange = () => { render(); if (go) go(i.value === 'free' ? 3 : 0); });
  $$('input[name=plan],input[name=pack]', extra).forEach(i => i.onchange = render);
  cta.onclick = () => {
    const t = tier();
    if (t === 'membership') { const p = $('input[name=plan]:checked', extra); addWithButton(cta, [{ id: +p.value, quantity: 1 }]); }
    else if (t === 'card') { const p = $('input[name=pack]:checked', extra); addWithButton(cta, [{ id: +cta.dataset.cardVariant, quantity: +p.value }]); }
    else { $('#tier-card').checked = true; render(); if (go) go(0); addWithButton(cta, [{ id: +cta.dataset.cardVariant, quantity: 1 }]); }
  };
  render();
}
let touchT;
function wireCounter() {
  const el = $('#touchesLive'); if (!el) return; const t0 = Date.now(); clearInterval(touchT);
  const rate = 2617 / (16 * 3600);
  touchT = setInterval(() => { el.textContent = ((Date.now() - t0) / 1000 * rate).toFixed(1); }, 250);
}
function fillRange(r) { const p = (r.value - r.min) / (r.max - r.min) * 100; r.style.setProperty('--fill', p + '%'); }
function wireLife() {
  const h = $('#lifeHrs'), a = $('#lifeAge'); if (!h) return;
  const up = () => { [h, a].forEach(fillRange); const hrs = +h.value, age = +a.value; $('#lifeHrsO').textContent = hrs + ' hrs'; $('#lifeAgeO').textContent = age; const yrs = hrs / 24 * Math.max(0, 80 - age); $('#lifeYears').textContent = yrs.toFixed(1) + ' years'; };
  h.oninput = a.oninput = up; up();
}

/* ---- discover map ---- */
const CATS = { Drink: '#005497', Move: '#1d7f55', Enjoy: '#b8428a', Events: '#d9503a', Eat: '#b3741a', 'Post Up': '#4a5bd1', Make: '#7a4fb5', Explore: '#2f8fae' };
const LISTINGS = [
  { c: 'Drink', t: 'Pints $2 off till 7', where: 'Ossington strip', km: .4, when: 'Now – 7:00pm', pts: 30, x: 318, y: 200 },
  { c: 'Move', t: 'Thursday 5K run club', where: 'Trinity Bellwoods gates', km: .7, when: 'Tonight 7:00pm', pts: 50, x: 372, y: 262 },
  { c: 'Enjoy', t: 'Late standup, $10 cover', where: 'Kensington Market', km: 1.1, when: 'Tonight 9:30pm', pts: 40, x: 452, y: 176 },
  { c: 'Events', t: 'Phone-free listening party', where: 'Queen West', km: .9, when: 'Fri 8:00pm', pts: 60, x: 404, y: 236 },
  { c: 'Eat', t: 'Sandwich counter open till 11', where: 'Dundas West', km: .5, when: 'Open now', pts: 20, x: 262, y: 176 },
  { c: 'Post Up', t: 'The café with no Wi-Fi on purpose', where: 'Little Italy', km: .8, when: 'Till 10:00pm', pts: 20, x: 352, y: 128 },
  { c: 'Make', t: 'Drop-in pottery wheel night', where: 'Junction Triangle', km: 1.6, when: 'Wed 7:00pm', pts: 40, x: 138, y: 96 },
  { c: 'Explore', t: 'Golden hour at the lake', where: 'Trillium Park', km: 2.2, when: 'Sunset', pts: 30, x: 300, y: 382 },
  { c: 'Drink', t: 'Natural wine, half-price bottles', where: 'Dundas & Ossington', km: .6, when: 'Tue–Thu', pts: 30, x: 296, y: 150 },
  { c: 'Move', t: 'Pickup volleyball', where: 'Stanley Park', km: 1.3, when: 'Sat 11:00am', pts: 40, x: 424, y: 318 }
];
function wireMap() {
  const map = $('#map'); if (!map) return;
  const streetsH = [['Bloor St W', 70], ['College St', 130], ['Dundas St W', 180], ['Queen St W', 232], ['King St W', 282]];
  const streetsV = [['Dufferin', 150], ['Ossington', 290], ['Bathurst', 410], ['Spadina', 500]];
  map.innerHTML = `<svg viewBox="0 0 600 440" role="img" aria-label="Stylized map of west-end Toronto with sample listings">
    <rect width="600" height="440" fill="#eaf2ff"/>
    <g transform="rotate(-8 300 220)">
      ${Array.from({ length: 24 }, (_, i) => `<line x1="${-60 + i * 30}" y1="-40" x2="${-60 + i * 30}" y2="480" stroke="#d6e4fb" stroke-width="1"/>`).join('')}
      ${Array.from({ length: 18 }, (_, i) => `<line x1="-60" y1="${-40 + i * 30}" x2="660" y2="${-40 + i * 30}" stroke="#d6e4fb" stroke-width="1"/>`).join('')}
      <rect x="340" y="240" width="70" height="46" rx="4" fill="#d5ebcf"/>
      <text x="345" y="280" font-family="Space Mono, monospace" font-size="8" fill="#1d7f55">TRINITY BELLWOODS</text>
      ${streetsH.map(([n, y]) => `<line x1="-60" y1="${y}" x2="660" y2="${y}" stroke="#ffffff" stroke-width="7"/><line x1="-60" y1="${y}" x2="660" y2="${y}" stroke="#b9cdee" stroke-width="1"/><text x="18" y="${y - 6}" font-family="Space Mono, monospace" font-size="9" fill="#2f6fae">${n}</text>`).join('')}
      ${streetsV.map(([n, x]) => `<line x1="${x}" y1="-40" x2="${x}" y2="480" stroke="#ffffff" stroke-width="7"/><line x1="${x}" y1="-40" x2="${x}" y2="480" stroke="#b9cdee" stroke-width="1"/><text x="${x + 6}" y="30" font-family="Space Mono, monospace" font-size="9" fill="#2f6fae" transform="rotate(90 ${x + 6} 30)">${n}</text>`).join('')}
    </g>
    <path d="M0 356 C 120 340, 200 372, 300 360 S 480 340, 600 352 L600 440 L0 440Z" fill="#8ebbff"/>
    <text x="440" y="416" font-family="Instrument Serif, serif" font-style="italic" font-size="20" fill="#005497">Lake Ontario</text>
    <circle cx="300" cy="228" r="120" fill="rgba(255,255,129,.18)" stroke="#005497" stroke-width="1.2" stroke-dasharray="4 5"/>
    <text x="300" y="100" text-anchor="middle" font-family="Space Mono, monospace" font-size="9" fill="#005497">10-MIN WALK</text>
    <g id="pins">${LISTINGS.map((l, i) => `<g class="pin" data-i="${i}" tabindex="0" role="button" aria-label="${esc(l.t)}, ${l.c}, ${l.km} km"><circle class="b" cx="${l.x}" cy="${l.y}" r="10" fill="#ffffef" stroke="${CATS[l.c]}" stroke-width="3"/><circle cx="${l.x}" cy="${l.y}" r="3.5" fill="${CATS[l.c]}"/></g>`).join('')}</g>
    <g><circle cx="300" cy="228" r="16" fill="rgba(0,84,151,.18)"><animate attributeName="r" values="10;22;10" dur="2.4s" repeatCount="indefinite"/></circle><circle cx="300" cy="228" r="7" fill="#005497" stroke="#fff" stroke-width="2.5"/></g>
  </svg>`;
  let cat = 'All', sel = null;
  const chips = $('#catChips');
  chips.innerHTML = ['All', ...Object.keys(CATS)].map(c => `<button class="chip" data-cat="${c}" aria-pressed="${c === cat}">${c}</button>`).join('');
  const list = $('#nearList');
  const draw = () => {
    const pool = LISTINGS.map((l, i) => ({ ...l, i })).filter(l => cat === 'All' || l.c === cat).sort((a, b) => a.km - b.km);
    const show = sel != null && !pool.slice(0, 3).some(l => l.i === sel) ? [LISTINGS[sel] && { ...LISTINGS[sel], i: sel }, ...pool.slice(0, 2)] : pool.slice(0, 3);
    $('#nearHead').textContent = pool.length ? (cat === 'All' ? 'Three things within 10 minutes of you' : `${cat} near you`) : 'Nothing in this category tonight';
    list.innerHTML = show.map(l => `<button class="listing ${l.i === sel ? 'on' : ''}" data-li="${l.i}"><span class="ic" style="background:${CATS[l.c]}22;color:${CATS[l.c]}">${l.c.slice(0, 4).toUpperCase()}</span><span><b>${esc(l.t)}</b><span class="meta">${esc(l.where)} · ${l.km} km · ${l.when}</span><br><span class="pts">+${l.pts} pts at tap-in</span></span></button>`).join('');
    $$('.pin', map).forEach(p => { const l = LISTINGS[+p.dataset.i]; p.classList.toggle('dim', !(cat === 'All' || l.c === cat)); p.classList.toggle('on', +p.dataset.i === sel); });
    $$('.chip', chips).forEach(b => b.setAttribute('aria-pressed', b.dataset.cat === cat));
    $$('[data-li]', list).forEach(b => b.onclick = () => { sel = +b.dataset.li; draw(); });
  };
  $$('.chip', chips).forEach(b => b.onclick = () => { cat = b.dataset.cat; sel = null; draw(); });
  $$('.pin', map).forEach(p => { const pick = () => { sel = +p.dataset.i; const c = LISTINGS[sel].c; if (cat !== 'All' && cat !== c) cat = 'All'; draw(); }; p.onclick = pick; p.onkeydown = e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } }; });
  draw();
}

/* ---- product page ---- */
function wirePDP() {
  const buy = $('#buy'); if (!buy) return;
  const cur = () => $('input[name=v]:checked', buy) || $('input[name=v]', buy);
  const upd = () => {
    const o = cur(); if (!o) return; const d = o.dataset;
    $('#pNow').textContent = d.price;
    const pp = $('#pPer'); pp.textContent = d.per || ''; pp.hidden = !d.per;
    const pw = $('#pWas'); pw.textContent = d.compare || ''; pw.hidden = !d.compare;
    const ps = $('#pSave'); ps.textContent = d.save ? 'Save ' + d.save : ''; ps.hidden = !d.save;
    const m = $('#pdpMeter'); if (m) m.hidden = d.founding !== '1';
    const atc = $('#atc'); atc.disabled = d.available === '0'; atc.textContent = d.available === '0' ? 'Sold out' : `Add to cart — ${d.price}`;
    $('#mbName').textContent = `${buy.dataset.title} · ${d.label}`;
    $('#mbPrice').textContent = d.price + (d.per || '');
  };
  $$('input[name=v]', buy).forEach(i => i.onchange = upd);
  $$('.seg button[data-href]', buy).forEach(b => b.onclick = () => { location.href = b.dataset.href + ($('#giftTog')?.checked ? '?gift=1' : ''); });
  const tog = $('#giftTog'), box = $('#giftBox');
  if (tog) { if (new URLSearchParams(location.search).get('gift') === '1') tog.checked = true; box.hidden = !tog.checked; tog.onchange = () => { box.hidden = !tog.checked; }; }
  const getGift = () => {
    if (!tog || !tog.checked) return {};
    const to = $('#gTo').value.trim();
    if (!to) { $('#gErr').textContent = 'Add their name so we can put it on the envelope.'; $('#gTo').classList.add('bad'); $('#gTo').focus(); return false; }
    $('#gErr').textContent = ''; $('#gTo').classList.remove('bad');
    const p = { 'Gift for': to }; const em = $('#gEmail').value.trim(), note = $('#gNote').value.trim();
    if (em) p['Gift email'] = em; if (note) p['Gift note'] = note; return p;
  };
  const item = props => { const d = cur().dataset; return [{ id: +d.variant, quantity: +(d.qty || 1), properties: props }]; };
  $('#atc').onclick = () => { const g = getGift(); if (g === false) return; addWithButton($('#atc'), item(g)); };
  $('#buyNow').onclick = async () => { const g = getGift(); if (g === false) return; if (await addWithButton($('#buyNow'), item(g), { open: false })) location.href = ROOT + 'checkout'; };
  if ($('#mbBtn')) $('#mbBtn').onclick = () => $('#atc').click();
  upd();
  const mbar = $('#mbar');
  if (mbar && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(([e]) => { const show = !e.isIntersecting && e.boundingClientRect.top < 0; mbar.classList.toggle('show', show); mbar.setAttribute('aria-hidden', !show); document.body.classList.toggle('has-mbar', show); });
    io.observe($('#atc'));
  }
}

/* ---- FAQ page ---- */
function wireFAQ() {
  const search = $('#faqSearch'); if (!search) return;
  $$('.faq-nav button').forEach(b => b.onclick = () => { $$('.faq-nav button').forEach(x => x.setAttribute('aria-pressed', x === b)); $('#faq-' + b.dataset.c).scrollIntoView({ behavior: 'smooth' }); });
  search.oninput = e => {
    const v = e.target.value.toLowerCase().trim(); let any = false;
    $$('.faq-group').forEach(g => { let has = false; $$('details', g).forEach(d => { const m = !v || d.textContent.toLowerCase().includes(v); d.hidden = !m; if (m) has = true; if (v && m) d.open = true; }); g.hidden = !has; any = any || has; });
    $('#faqNone').hidden = any;
  };
  const h = location.hash.replace('#', '');
  if (h.startsWith('faq-') && $('#' + h)) { const d = $('details', $('#' + h)); if (d) d.open = true; const b = $(`.faq-nav button[data-c="${h.slice(4)}"]`); if (b) $$('.faq-nav button').forEach(x => x.setAttribute('aria-pressed', x === b)); }
}

/* ---- business calculator ---- */
function wireCalc() {
  const els = { emp: $('#cEmp'), empN: $('#cEmpN'), sal: $('#cSal'), min: $('#cMin'), rec: $('#cRec') }; if (!els.emp) return;
  const big = n => n >= 1e6 ? '$' + (n / 1e6).toFixed(n >= 1e7 ? 1 : 2) + 'M' : dollars(n);
  const calc = () => {
    [els.emp, els.sal, els.min, els.rec].forEach(fillRange);
    const emp = Math.max(1, +els.empN.value || 1), sal = +els.sal.value, min = +els.min.value, rate = +els.rec.value / 100;
    const hourly = sal / 2000, hrsLost = min / 60 * 250, riskP = hrsLost * hourly, riskC = riskP * emp, recP = riskP * rate, recC = recP * emp, cost = 40 * emp, roi = recC / cost;
    $('#cSalO').textContent = dollars(sal); $('#cMinO').textContent = min >= 60 ? `${min} min · ${(min / 60).toFixed(1)} hr` : `${min} min`; $('#cRecO').textContent = Math.round(rate * 100) + '%';
    $('#oRiskP').textContent = dollars(Math.round(riskP)); $('#oRiskC').textContent = big(Math.round(riskC)); $('#oRecP').textContent = dollars(Math.round(recP)); $('#oRecC').textContent = big(Math.round(recC));
    $('#oHrsP').textContent = `${fmt(hrsLost * rate)} hours back each`; $('#oHrsC').textContent = `${fmt(hrsLost * rate * emp)} hours company-wide`;
    $('#oCost').textContent = dollars(cost); $('#oRoi').textContent = `${roi >= 10 ? fmt(roi) : roi.toFixed(1)} : 1`;
    $('#barCost').style.width = Math.max(.6, Math.min(100, cost / recC * 100)) + '%';
    $('#oStatus').textContent = `${fmt(emp)} employees · ${dollars(sal)} · ${min} min · ${Math.round(rate * 100)}%`;
    $$('.presets button').forEach(b => b.setAttribute('aria-pressed', +b.dataset.m === min));
  };
  els.emp.oninput = () => { els.empN.value = els.emp.value; calc(); };
  els.empN.oninput = () => { els.emp.value = Math.min(2000, Math.max(5, +els.empN.value || 5)); calc(); };
  [els.sal, els.min, els.rec].forEach(e => e.oninput = calc);
  $$('.presets button').forEach(b => b.onclick = () => { els.min.value = b.dataset.m; calc(); });
  calc();
}

/* ---- forms ---- */
function wireForms() {
  $$('form.lead-form').forEach(f => {
    f.noValidate = true;
    f.addEventListener('submit', e => {
      let ok = true, first = null;
      $$('[required]', f).forEach(i => { const bad = !i.value.trim() || (i.type === 'email' && !EMAIL.test(i.value.trim())); i.classList.toggle('bad', bad); const er = i.parentElement.querySelector('.err'); if (er) er.textContent = bad ? (i.type === 'email' ? 'Enter an email we can reply to.' : "This one's required.") : ''; if (bad) { ok = false; first = first || i; } });
      if (!ok) { e.preventDefault(); first.focus(); return; }
      $$('[data-join]', f).forEach(h => { h.value = $$(`input[data-join-src="${h.dataset.join}"]:checked`, f).map(c => c.value).join(', '); });
    });
  });
  const nf = $('#newsForm');
  if (nf) { nf.noValidate = true; nf.addEventListener('submit', e => { const v = ($('#newsEmail') || {}).value || ''; if (!EMAIL.test(v.trim())) { e.preventDefault(); $('#newsErr').textContent = 'That email looks off. Check for a typo.'; } }); }
  const nom = $('#nomForm');
  if (nom) nom.onsubmit = e => {
    e.preventDefault(); const v = $('#nomSchool').value.trim(); if (!v) { $('#nomErr').textContent = 'Type your school first.'; return; }
    const link = `${location.host}${location.pathname}?from=${encodeURIComponent(v.toLowerCase().split(' ').filter(Boolean).join('-'))}`;
    nom.parentElement.innerHTML = `<h4>Nominated: ${esc(v)}.</h4><p class="small">Now tell your student union. A link from a student gets opened; an email from us gets filed.</p><div class="copy-row"><input class="input" id="nomLink" readonly value="${esc(link)}"><button class="btn sm" id="nomCopy">Copy</button></div>`;
    $('#nomCopy').onclick = () => copyText('https://' + $('#nomLink').value);
  };
}
function copyText(t) { try { navigator.clipboard.writeText(t).then(() => toast('Copied.'), () => toast('Select the link and copy it.')); } catch (e) { toast('Select the link and copy it.'); } }

/* ---- boot ---- */
function init() {
  initArt();
  wireShell();
  Cart.refresh().catch(() => {});
  $$('.gallery').forEach(g => { const go = wireGallery(g); if (g.id === 'heroGal') wireTiers(go); });
  wireCounter(); wireLife(); wireMap(); wirePDP(); wireFAQ(); wireCalc(); wireForms();
  document.addEventListener('shopify:section:load', e => { applyArt(e.target); });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();